import type { QueryClient } from '@tanstack/react-query'

/**
 * #271: an obligation dismissed or settled, time logged, or a case updated changes the named case plus aggregate
 * queue/nav/ledger/Home views. Do not invalidate every cached case or unrelated close-out settings and histories.
 */
export const CASE_STATE_AGGREGATES = ['queue', 'nav', 'ledger', 'home', 'my-day'] as const
const CLOSEOUT_AGGREGATES = new Set(['batch', 'reminders', 'preview', 'stale-closes'])

export function invalidateCaseState(qc: QueryClient, caseIds: readonly string[]): Promise<void> {
  const ids = new Set(caseIds)
  const aggregates = new Set<unknown>(CASE_STATE_AGGREGATES)
  return qc.invalidateQueries({
    predicate: ({ queryKey }) => {
      const [root, section, id] = queryKey
      if (aggregates.has(root)) return true
      if (root === 'case') return typeof section === 'string' && ids.has(section)
      if (root !== 'closeout' || typeof section !== 'string') return false
      return (
        CLOSEOUT_AGGREGATES.has(section) ||
        ((section === 'case' || section === 'followups' || section === 'staff-reminders') && typeof id === 'string' && ids.has(id))
      )
    },
  })
}
